import LevelComponent from "../levelComponent";
import Avatar from "@material-ui/core/Avatar";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import Tooltip from "@material-ui/core/Tooltip";
import { DeleteButtonForToolBar } from "../../common/buttons";
import { getTime, isInactivityPolicy, renderDataSource } from "../../common/utilities";
import ViewDatabase from "../../../assets/icons/viewDatabase.svg";
import ViewDatabaseDisabled from "../../../assets/icons/viewDatabaseDisabled.svg";
import { withStyles } from "@material-ui/core/styles";
import ViewTooltip from "@material-ui/core/Tooltip";
import { renderDateTime } from "../../views/Util/ViewCommon";
import { viewAlertPolicy, viewDatabaseLogs } from "../../../redux/constants/constants";
import CanAllow from "../CanAllow";
import { isNull } from "lodash";
import { maskUsername } from "../../../features/SysGuard/SysGuardCommonComp";


const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
  arrow: {
    fontSize: 16,
    width: 17,
    "&::before": {
      border: "1px solid #fff",
      backgroundColor: "white",
      boxSizing: "border-box",
      boxShadow: " 0 0 2px #0004",
    },
  },
  disbaled:{
    opacity:"0.5"
  }
}))(ViewTooltip);

const avatarThumbnails = (rowData) => {
  return (
    <AvatarGroup className="avatar-root" max={4}>
      {rowData.monitors && rowData.monitors !== null
        ? rowData.monitors.map((each, index) => {
            let temp = each.monitorThumbnail;
            return (
              !each.muted && (
                <Tooltip title={temp.name}>
                  <Avatar
                    className="avatar"
                    id={index}
                    alt={temp.name}
                    elevation={4}
                    src={`data:image/png;base64, ${temp.picture}`}
                  />
                </Tooltip>
              )
            );
          })
        : rowData.alertPolicy && rowData.alertPolicy.monitors !== null
        ? rowData.alertPolicy.monitors.map((each, index) => {
            let temp = each.monitorThumbnail;
            return (
              !each.muted && (
                <Tooltip title={temp.name}>
                  <Avatar
                    className="avatar"
                    id={index}
                    alt={temp.name}
                    elevation={4}
                    src={`data:image/png;base64, ${temp.picture}`}
                  />
                </Tooltip>
              )
            );
          })
        : rowData.alertPolicy && rowData.alertPolicy.monitors !== null
        ? rowData.alertPolicy.monitors.map((each, index) => {
            let temp = each.monitorThumbnail;
            return (
              !each.muted && (
                <Tooltip title={temp.name}>
                  <Avatar
                    className="avatar"
                    id={index}
                    alt={temp.name}
                    elevation={4}
                    src={temp.picture}
                  />
                </Tooltip>
              )
            );
          })
        : ""}
    </AvatarGroup>
  );
};
export const displayName = (name) => {
  return (
    <span>{name}</span>
  )
}
export const filterUserForInactivityPolicy = (rowData, history, dispatch) => {
  if (
    rowData &&
    rowData.enterpriseActor &&
    rowData.enterpriseActor.username &&
    rowData.alertPolicy &&
    isInactivityPolicy(rowData.alertPolicy.type)
  ) {
    history.push(
      `/tenant/useraccessRights`
    );
    dispatch({
      type: 'UPDATE_SEARCH_VALUE',
      payload: rowData.enterpriseActor.username,
    });
  }
};
const inactivityPolicyUsername = (rowData) => {
  if(
    rowData.alertPolicy &&
    isInactivityPolicy(rowData.alertPolicy.type)
  ){
    return "inactivityPolicyUsername"
  }
}

const getAccessLogProps = (featuresEnabled, policyName) => {
  const isDisabled =
    featuresEnabled === true || policyName === "Unusual Access Path";

  return {
    className: isDisabled ? "disbaled" : "",
    style: isDisabled ? { opacity: 0.5, cursor: "not-allowed" } : {},
    disabled: isDisabled,
  };
};
 
export const tableConstants = (
  toggleDrawer,
  getTime,
  dispatch,
  history,
  project,
  isIncognito,
  loc
) => {
  const featuresData = JSON.parse(localStorage.getItem("featuresInfo"));
  const features =
    featuresData &&
    featuresData.features &&
    featuresData.features.filter((data) => data.name === "Data Vision");

  let featuresEnabled =
    features && features.length && features[0].licenseType.name !== "Platinum";

  const columns = [
    {
      title: "Severity Level",
      orderId: "alertPolicy.severity",
      style: { width: "10%" },
      rowBodyCellStyle: { width: "10%" },
      render: (rowData) => (
        <LevelComponent level={rowData.severity.toUpperCase()} />
      ),
    },
    {
      title: "Time",
      orderId: "generatedOn",
      style: { width: "10%" },
      rowBodyCellStyle: { width: "10%", whiteSpace: "nowrap" },
      render: (rowData) => (
        <span
          className="mousePointer"
          onClick={(event) => toggleDrawer(true, event, rowData.id)}
        >
          {renderDateTime(rowData.generatedOn)}
        </span>
      ),
    },
    {
      title: "Policy Name",
      orderId: "alertPolicy.name",
      style: { width: "13%" },
      rowBodyCellStyle: { width: "13%" },
      render: (rowData) => (
        <CanAllow
          needs={{ permission: [viewAlertPolicy] }}
          component={displayName(rowData.alertPolicy.name)}
        >
          <span
            style={{
              color: project !== "MDR" ? "#081981" : "inherit",
              cursor: project !== "MDR" ? "pointer" : "default",
            }}
            onClick={() => {
              if (project !== "MDR") {
                dispatch({
                  type: "TRACK_TRAVERSAL",
                  payload: `Alert Policies - ${rowData.alertPolicy.name}`,
                });
                history.push(`/tenant/alertPolicies/${rowData.alertPolicy.id}`);
              }
            }}
            className={project !== "MDR" ? "mousePointer" : ""}
          >
            {rowData.alertPolicy.name}
          </span>
        </CanAllow>
      ),
    },

    {
      title: "Alert Violation",
      orderId: "type",
      style: { width: "15%" },
      rowBodyCellStyle: { width: "15%" },
      render: (rowData) => {
        const violation_text = rowData.alertViolationTxt;
        return <span>{violation_text || rowData.type || ""}</span>;
      },
    },
    {
      title: "Alert Violation Details",
      orderId: "reason",
      style: { width: "20%" },
      rowBodyCellStyle: { width: "20%", cursor: "pointer" },
      render: (rowData) => (
        <span
          className="alert-violation-data"
          title={rowData.reason || ""}
          onClick={(event) => toggleDrawer(true, event, rowData.id)}
        >
          {rowData.reason || ""}
        </span>
      ),
    },

    {
      title: "Data Source Name",
      orderId: "dataSource.aliasName",
      style: { width: "13%" },
      rowBodyCellStyle: { width: "13%", wordBreak: "break-all" },
      render: (rowData) => {
        const dataSourceType = rowData.dataSource
          ? rowData.dataSource.type.code
          : "";
        const dataSourceName = rowData.dataSource?.aliasName || "";
        return <span>{renderDataSource(dataSourceType, dataSourceName)}</span>;
      },
    },
    {
      title: "Username",
      orderId: "enterpriseActor.username",
      style: { width: "10%" },
      rowBodyCellStyle: { width: "10%", wordBreak: "break-word" },
      render: (rowData) => (
        <span
          onClick={() => {
            filterUserForInactivityPolicy(rowData, history, dispatch);
          }}
          className={inactivityPolicyUsername(rowData)}
        >
          {isIncognito && project === "MDR"
            ? maskUsername(rowData.enterpriseActor?.username || "")
            : rowData.enterpriseActor?.username || ""}
        </span>
      ),
    },
    {
      title: "Tickets",
      style: { width: "10%" },
      rowBodyCellStyle: { width: "10%" },
      render: (rowData) => (
        <span>{rowData.tickets?.map((t) => t.ticketId).join(", ")}</span>
      ),
    },
  ];

  if (loc === "ResolvedAlerts") {
    const ticketsIndex = columns.findIndex((col) => col.title === "Tickets");

    columns.splice(ticketsIndex, 0, {
      title: "Status",
      style: { width: "8%" },
      rowBodyCellStyle: { width: "8%" },
      render: (rowData) => <span>{rowData.status || "-"}</span>,
    });
  }

  if (loc === "ResolvedAlerts") {
    columns.push({
      title: "Resolved By",
      style: { width: "20%", whiteSpace: "nowrap" },
      rowBodyCellStyle: { width: "20%", },
      render: (rowData) => {
        const userNames = rowData.actionTrail
          ?.map((action) => action.userName)
          .join(", ");
        return <span>{userNames || "-"}</span>;
      },
    });
  }

  // Add the "Action" column only if project is not "MDR"
  if (project !== "MDR") {
    columns.push({
      title: "Action",
      style: { width: "5%" },
      rowBodyCellStyle: { width: "5%" },
      render: (rowData) => {
        const isServiceLevel =
          rowData.alertPolicy.type.code === "SERVICE_LEVEL_ACCESS";
        const { className, style, disabled } = getAccessLogProps(
          featuresEnabled,
          rowData.alertPolicy.name
        );

        if (isServiceLevel) {
          return (
            <DeleteButtonForToolBar
              variant="contained"
              id="delete"
              size="small"
              color="primary"
              onClick={() => {
                history.push({
                  pathname: "/tenant/databaseLogs",
                  state: {
                    alertId: rowData.id,
                    configuration: rowData.configuration,
                    tag: "serviceLogs",
                  },
                });
              }}
              className={className}
              style={style}
              disabled={disabled}
            >
              <LightTooltip title="View Service Access Logs" arrow>
                <img src={ViewDatabase} alt="view-database-logs" />
              </LightTooltip>
            </DeleteButtonForToolBar>
          );
        }

        const isInactive =
          isInactivityPolicy(rowData.alertPolicy.type) ||
          isNull(rowData.configuration);
        return (
          <div className={isInactive ? "alertsTableDisable" : ""}>
            <DeleteButtonForToolBar
              variant="contained"
              id="delete"
              size="small"
              color="primary"
              className="min-margin"
              onClick={() => {
                history.push({
                  pathname: "/tenant/databaseLogs",
                  state: {
                    alertId: rowData.id,
                    configuration: rowData.configuration,
                    tag: "directDbLogs",
                  },
                });
              }}
              disabled={isInactive}
            >
              <LightTooltip title="View Data Access Logs" arrow>
                <img
                  src={isInactive ? ViewDatabaseDisabled : ViewDatabase}
                  alt="view-data-access-logs"
                />
              </LightTooltip>
            </DeleteButtonForToolBar>
          </div>
        );
      },
      requiredPermission: viewDatabaseLogs,
    });
  }
  return columns;
};


export const relatedTableConstants = () => {
  return [
    {
      title: "Level",
      render: (rowData) => {
        return (
          <LevelComponent level={rowData.severity.toUpperCase()} />
        );
      },
    },
    {
      title: "Time",
      render: (rowData) => {
        return <span>{getTime(rowData.generatedOn)}</span>;
      },
    },
    {
      title: "Policy",
      render: (rowData) => {
        return <span>{rowData.alertPolicy.name}</span>;
      },
    },
  ];
};
